import { render, staticRenderFns } from "./BandejaObservacionesDiagnostico.vue?vue&type=template&id=0578a06e"
import script from "./BandejaObservacionesDiagnostico.vue?vue&type=script&lang=js"
export * from "./BandejaObservacionesDiagnostico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports